/* eslint-disable  */
import React from 'react'
import RenderAdminPage from '../RenderAdminPage'
import { useHistory } from 'react-router-dom'
import "./LoanBookings.css";
import "./FundIncrement.css";
import * as FileServer from "file-saver";

function FundIncrementDetailed() {
    const history = useHistory()
    const fundIncrement = history.location.state.state
    console.log('history', fundIncrement)

    const handleImageDownload = (url, name) => {
        // alert("front image download");
        FileServer.saveAs(url, name);
    };

    function getFileExtension(url) {
        // Use the URL constructor to extract the pathname from the URL
        const pathname = new URL(url).pathname;
      
        // Use a regular expression to extract the file extension
        const extensionMatch = /\.[0-9a-z]+$/i.exec(pathname);
      
        // Check if a match was found and return the extension (including the dot)
        return extensionMatch ? extensionMatch[0] : null;
      }
       const url = fundIncrement?.files[1].url;
const fileExtension = getFileExtension(url);

console.log('fileExtension', fileExtension);

    return (
    <div>
      <RenderAdminPage title="Fund Increment Details">
        <button
          onClick={() => history.goBack()}
          className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-slate-100 dark:bg-gray-700 text-slate-700 dark:text-slate-300 hover:bg-slate-200 dark:hover:bg-gray-600 text-sm font-semibold transition-colors mb-4"
        >
          ← Back
        </button>

        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-slate-200 dark:border-gray-700 p-6 mb-6">
          <div className="flex items-center gap-4">
            <img
              className="w-16 h-16 rounded-full object-cover border-2 border-slate-200 dark:border-gray-600"
              src={fundIncrement?.files[2]?.url || "/images/dev/del.png"}
              alt="profile"
            />
            <div>
              <h3 className="text-lg font-bold text-slate-800 dark:text-slate-100">{fundIncrement?.name}</h3>
              <p className="text-sm text-slate-500 dark:text-slate-400">{fundIncrement?.staff_id}</p>
            </div>
          </div>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-slate-200 dark:border-gray-700 p-6 mb-6">
          <div className="space-y-0">
            <div className="flex justify-between py-3 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Full Name</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{fundIncrement?.name}</span>
            </div>
            <div className="flex justify-between py-3 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Staff ID</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{fundIncrement?.staff_id}</span>
            </div>
            <div className="flex justify-between py-3 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Current Contribution</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{fundIncrement?.current_contribution}</span>
            </div>
            <div className="flex justify-between py-3 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Requested Amount</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{fundIncrement?.requested_increment}</span>
            </div>
            <div className="flex justify-between py-3 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Ghana Card Number</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{fundIncrement?.IDCardNumber}</span>
            </div>
            <div className="flex justify-between py-3 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Facility</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{fundIncrement?.facility}</span>
            </div>
            <div className="flex justify-between py-3 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Date of Birth</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{fundIncrement?.dob}</span>
            </div>
            <div className="flex justify-between py-3 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Mandate Number</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{fundIncrement?.mandate_number}</span>
            </div>
            <div className="flex justify-between py-3 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Next of Kin</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{fundIncrement?.next_of_kin}</span>
            </div>
            <div className="flex justify-between py-3 border-b border-slate-100 dark:border-gray-700">
              <span className="text-sm text-slate-500 dark:text-slate-400">Start Date</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{fundIncrement?.fromDate}</span>
            </div>
            <div className="flex justify-between py-3">
              <span className="text-sm text-slate-500 dark:text-slate-400">End Date</span>
              <span className="text-sm font-medium text-slate-800 dark:text-slate-200">{fundIncrement?.toDate}</span>
            </div>
          </div>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-slate-200 dark:border-gray-700 p-6">
          <h3 className="text-base font-bold text-slate-800 dark:text-slate-100 mb-4">Files Uploaded</h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
            {getFileExtension(fundIncrement?.files[0]?.url) === '.pdf' && (
              <div className="flex flex-col items-center gap-2 p-4 rounded-xl border border-slate-200 dark:border-gray-700 hover:bg-slate-50 dark:hover:bg-gray-700/30 cursor-pointer transition-colors" onClick={() => handleImageDownload(fundIncrement?.files[0].url, "document.pdf")}>
                <img src="/images/dev/pdf.png" alt="pdf" className="w-12 h-12" />
                <span className="text-xs text-slate-500 dark:text-slate-400">Payslip</span>
              </div>
            )}
            {getFileExtension(fundIncrement?.files[1]?.url) === '.pdf' && (
              <div className="flex flex-col items-center gap-2 p-4 rounded-xl border border-slate-200 dark:border-gray-700 hover:bg-slate-50 dark:hover:bg-gray-700/30 cursor-pointer transition-colors" onClick={() => handleImageDownload(fundIncrement?.files[1].url, "document.pdf")}>
                <img src="/images/dev/pdf.png" alt="pdf" className="w-12 h-12" />
                <span className="text-xs text-slate-500 dark:text-slate-400">Document</span>
              </div>
            )}
            {getFileExtension(fundIncrement?.files[2]?.url) === '.pdf' && (
              <div className="flex flex-col items-center gap-2 p-4 rounded-xl border border-slate-200 dark:border-gray-700 hover:bg-slate-50 dark:hover:bg-gray-700/30 cursor-pointer transition-colors" onClick={() => handleImageDownload(fundIncrement?.files[2].url, "document.pdf")}>
                <img src="/images/dev/pdf.png" alt="pdf" className="w-12 h-12" />
                <span className="text-xs text-slate-500 dark:text-slate-400">Document</span>
              </div>
            )}
            <div className="rounded-xl border border-slate-200 dark:border-gray-700 overflow-hidden cursor-pointer hover:opacity-80 transition-opacity" onClick={() => handleImageDownload(fundIncrement?.files[1].url, "image.png")}>
              <img src={fundIncrement?.files[1]?.url} alt="id_back" className="w-full h-32 object-cover" />
            </div>
            <div className="rounded-xl border border-slate-200 dark:border-gray-700 overflow-hidden cursor-pointer hover:opacity-80 transition-opacity" onClick={() => handleImageDownload(fundIncrement?.files[2].url, "image.png")}>
              <img src={fundIncrement?.files[2]?.url} alt="id_front" className="w-full h-32 object-cover" />
            </div>
          </div>
        </div>
      </RenderAdminPage>
    </div>
  )
}

export default FundIncrementDetailed